/*
 * @Author: your name
 * @Date: 2021-12-02 16:55:35
 * @LastEditTime: 2021-12-02 16:58:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \vue3-element-admin\src\store\modules\app\MyMap.js
 */
import {
    TOGGLE_SLIDER,
    SET_TOKEN,
    SET_UNAME,
    SET_USER_INFO,
    SET_MENU_LIST,
    SET_USER_LOCATION,
    SET_MINI_USER_ID,
    SET_ACTION_NUM,
    SET_TIPS_SHOW,
    SET_GARDEN_EXAMPLE,
    SET_USER_ROLES, SET_USER_CUR_ROLE,SET_KEY
} from "./type.js";
export default {
    namespaced: true,
    state: {
        token: localStorage.getItem("token") || "",
        authkey:null,
        uname: sessionStorage.getItem("uname") || "",
        isExampleGarden: localStorage.getItem("isExampleGarden") || "",
        roles: localStorage.getItem(SET_USER_ROLES) || [],
        curRole: localStorage.getItem(SET_USER_CUR_ROLE) || 0,
    },
    mutations: {
        [SET_TOKEN](state, token) {
            state.token = token;
            localStorage.setItem("token", state.token);
        },
        [SET_KEY](state, autokey) {
            state.authkey = autokey;
        },
        ["djiCloudToken"](state, djiCloudToken) {
            state.djiCloudToken = djiCloudToken;
            sessionStorage.setItem("djiCloudToken", state.djiCloudToken);
        },
        [SET_UNAME](state, uname) {
            state.uname = uname;
            sessionStorage.setItem("uname", state.uname);
        },
        [SET_USER_INFO](state, userinfoStr) {
            sessionStorage.setItem("userinfo", userinfoStr);
        },
        [SET_USER_LOCATION](state, userLocation) {
            state.userLocation = userLocation
            sessionStorage.setItem("userLocation", userLocation);
        },
        [SET_MINI_USER_ID](state, miniUserId) {
            state.miniUserId = miniUserId
            sessionStorage.setItem("miniUserId", miniUserId);
        },
        [SET_ACTION_NUM](state, actionNum) {
            state.actionNum = actionNum
            // localStorage.setItem("actionNum", actionNum);
        },
        [SET_TIPS_SHOW](state, tips) {
            state.tips = tips
            sessionStorage.setItem("tips", tips);
        },
        [SET_GARDEN_EXAMPLE](state, isExampleGarden) {
            state.isExampleGarden = isExampleGarden
            localStorage.setItem("isExampleGarden", isExampleGarden);
        },
        [SET_USER_ROLES](state, roles) {
            state.roles = JSON.stringify(roles)
            localStorage.setItem(SET_USER_ROLES, state.roles);
        },
        [SET_USER_CUR_ROLE](state, role) {
            state.curRole = role
            localStorage.setItem(SET_USER_CUR_ROLE, role);
        },
    },
    actions: {
        [TOGGLE_SLIDER]({ commit }) {
            commit(TOGGLE_SLIDER);
        },
        [SET_TOKEN]({ commit }, token) {
            commit(SET_TOKEN, token);
        },
        [SET_KEY]({ commit }, authkey) {
            commit(SET_KEY, authkey);
        },
        ["djiCloudToken"]({ commit }, djiCloudToken) {
            commit("djiCloudToken", djiCloudToken);
        },
        [SET_UNAME]({ commit }, uname) {
            commit(SET_UNAME, uname);
        },
        [SET_MENU_LIST]({ commit }, menuList) {
            commit(SET_MENU_LIST, menuList);
        },
        [SET_USER_LOCATION]({ commit }, userLocation) {
            commit(SET_USER_LOCATION, userLocation);
        },
        [SET_MINI_USER_ID]({ commit }, miniUserId) {
            commit(SET_MINI_USER_ID, miniUserId);
        },
        [SET_ACTION_NUM]({ commit }, actionNum) {
            let num = localStorage.getItem("actionNum");
            commit(SET_ACTION_NUM, num);
        },
        [SET_TIPS_SHOW]({ commit }, tips) {
            commit(SET_TIPS_SHOW, tips);
        },
        [SET_GARDEN_EXAMPLE]({ commit }, isExampleGarden) {
            commit(SET_GARDEN_EXAMPLE, isExampleGarden);
        },
        [SET_USER_ROLES]({ commit }, roles) {
            commit(SET_USER_ROLES, roles);
        },
        [SET_USER_CUR_ROLE]({ commit }, role) {
            commit(SET_USER_CUR_ROLE, role);
        },
    },
};
